export const sanitizeInput = (str: string) => {
  if (!str) return '';
  return str.replace(/[&<>"'/]/g, (char) => {
    const entities: { [key: string]: string } = {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;',
      '/': '&#x2F;',
    };
    return entities[char] || char;
  });
};